var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.get_OCSDateTime = function (ops) {
    if (!OCS.Live.OCSDateTime) {
        if(!OCS.Classes.OCSDateTime) {
            OCS.Classes.OCSDateTime = OCS.Functions.define_OCSDateTime();
        }
        new OCS.Classes.OCSDateTime(ops);
    }
    return OCS.Live.OCSDateTime;
};